export default __webpack_public_path__ + "static/media/tolet2.b2a89157.jpeg";